<form [formGroup]="formGroup" (ngSubmit)="submit()">
  <!-- EOD team -->
  <app-input
    label="EOD Team Dispatched"
    i18n-label="@@eodTeamDispatchedLabel"
    formControlName="eodTeamDispatched"
    [touched]="formGroup.get('eodTeamDispatched')?.touched"
    [errorMessage]="formGroup.get('eodTeamDispatched')?.errors">
  </app-input>

  <!-- Departure / Arrival -->
  <app-input-datetime
    label="Departure Date/Time"
    i18n-label="@@departureDateTimeLabel"
    formControlName="departureDate"
    [touched]="formGroup.get('departureDate')?.touched"
    [errorMessage]="formGroup.get('departureDate')?.errors">
  </app-input-datetime>

  <app-input-datetime
    label="Arrival Date/Time"
    i18n-label="@@arrivalDateTimeLabel"
    formControlName="arrivalDate"
    [touched]="formGroup.get('arrivalDate')?.touched"
    [errorMessage]="formGroup.get('arrivalDate')?.errors">
  </app-input-datetime>

  <!-- Narrative -->
  <app-input
    label="Narrative"
    i18n-label="@@narrativeLabel"
    formControlName="narrative"
    type="textarea"
    [touched]="formGroup.get('narrative')?.touched"
    [errorMessage]="formGroup.get('narrative')?.errors">
  </app-input>

  <!-- Disposition picker -->
  <app-input-select
    label="Disposition"
    i18n-label="@@dispositionLabel"
    formControlName="disposition"
    [options]="dispositionOptions"
    [touched]="formGroup.get('disposition')?.touched"
    [errorMessage]="formGroup.get('disposition')?.errors">
  </app-input-select>

  <!-- Completed date -->
  <app-input-datetime
    label="Completed Date"
    i18n-label="@@completedDateLabel"
    formControlName="completedDate"
    [touched]="formGroup.get('completedDate')?.touched"
    [errorMessage]="formGroup.get('completedDate')?.errors">
  </app-input-datetime>

  <!-- EOD Images dropzone -->
  <app-image-upload-dropzone
    *ngIf="deleteable"
    label="EOD Images"
    i18n-label="@@eodImagesLabel"
    [images]="eodImages"
    (imageSelected)="onImageAdd($event)"
    (deleteImage)="onDeleteImage($event)"
    [deleteable]="deleteable"
  ></app-image-upload-dropzone>


  <app-row>
    <app-input
      label="Width (mm)"
      i18n-label="@@widthMmLabel"
      formControlName="widthCm"
      [touched]="formGroup.get('widthCm')?.touched"
      [errorMessage]="formGroup.get('widthCm')?.errors">
    </app-input>

    <app-input
      label="Length (mm)"
      i18n-label="@@lengthMmLabel"
      formControlName="lengthCm"
      [touched]="formGroup.get('lengthCm')?.touched"
      [errorMessage]="formGroup.get('lengthCm')?.errors">
    </app-input>
  </app-row>
  <app-row>
    <app-input
      label="Height (mm)"
      i18n-label="@@heightMmLabel"
      formControlName="heightCm"
      [touched]="formGroup.get('heightCm')?.touched"
      [errorMessage]="formGroup.get('heightCm')?.errors">
    </app-input>

    <app-input
      label="Diameter (mm)"
      i18n-label="@@diameterMmLabel"
      formControlName="diameterCm"
      [touched]="formGroup.get('diameterCm')?.touched"
      [errorMessage]="formGroup.get('diameterCm')?.errors">
    </app-input>
  </app-row>
</form>